/**
 * Einheitlicher Logout: Business-Session beenden → Login-Seite (Benutzer/Passwort).
 * Nicht verwechseln mit Rollen-Code (CodeEntryModal).
 */

import { kvRemove, kvKeysStartingWith } from '../infrastructure/storage/kvAccess';
import { roleStorageKey } from './roleStorage';
import { clearCashRegisterPaused } from './cashRegisterPause';

export function clearRoleSessionStorage(businessId) {
  if (businessId) {
    kvRemove(roleStorageKey(businessId));
    clearBusinessPauseFlags(businessId);
  }
  kvKeysStartingWith('currentRole_').forEach((key) => {
    kvRemove(key);
  });
  kvRemove('currentRole');
  kvRemove('workerDashboardState');
}

/** Entfernt Pause-Flags (optional nur für ein Business). */
export function clearBusinessPauseFlags(businessId = null) {
  clearCashRegisterPaused(businessId || null);
}

/**
 * @param {{ businessId?: string|null }} [options]
 */
export async function logoutToBusinessLoginPage() {
  const { completeLogout } = await import('../services/completeLogoutService');
  await completeLogout({ reload: false });
}
